import React from "react";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import { MdAddIcCall } from "react-icons/md";
import { MdAttachEmail } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { FiInstagram } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";

const Topbar = () => {
  return (
    <div className="container-fluid topbar bg-secondary d-none d-xl-block w-100">
      <div className="container">
        <div className="row gx-0 align-items-center" style={{ height: "45px" }}>
          <div className="col-lg-6 text-center text-lg-start mb-lg-0">
            <div className="d-flex flex-wrap">
              <Link to="/" className="text-muted me-4 d-flex ">
                <FaLocationDot
                  style={{ marginTop: "9px", marginRight: "2px" }}
                />
                <p className="mt-1">Limuru Town. Nairobi, Kenya</p>
              </Link>
              <Link to="tel:+01234567890" className="text-muted me-4 d-flex">
                <MdAddIcCall style={{ marginTop: "9px", marginRight: "2px" }} />{" "}
                <p className="mt-1">0713 624 100</p>
              </Link>
              <Link
                to="mailto:stewardcars@gmail.com"
                className="text-muted me-0 d-flex"
              >
                <MdAttachEmail
                  style={{ marginTop: "9px", marginRight: "2px" }}
                />{" "}
                <p className="mt-1">stewardcars@gmail.com</p>
              </Link>
            </div>
          </div>
          <div className="col-lg-6 text-center text-lg-end">
            <div className="d-flex align-items-center justify-content-end">
              <Link
                to="#"
                className="btn btn-light btn-sm-square rounded-circle me-3"
              >
                <FaWhatsapp />
              </Link>
              <Link
                to="#"
                className="btn btn-light btn-sm-square rounded-circle me-3"
              >
                <CiFacebook />
              </Link>
              <Link
                to="#"
                className="btn btn-light btn-sm-square rounded-circle me-3"
              >
                <FiInstagram />
              </Link>
              <Link
                to="#"
                className="btn btn-light btn-sm-square rounded-circle me-0"
              >
                <FaXTwitter />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
